export default __webpack_public_path__ + "static/media/page8Image2.6aaa5255.jpeg";